import { combineReducers } from "redux";
import surveyReducer from "./surveyReducer";
import { routerReducer } from "react-router-redux";
import { reducer as formReducer } from "redux-form";

const rootReducer = combineReducers({
  $surveyStore: surveyReducer,
  routing: routerReducer,
  form: formReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js